export const TOKEN_KEY = 'vb_token';
export const USER_ID_KEY = 'vb_user_id';
export const LAST_AUTH_AT_KEY = 'vb_last_auth_at';
export const AUTH_EVENT = 'vb-auth-change';
const CHANNEL_NAME = 'vb-auth';

export function getStoredToken() {
  try {
    return localStorage.getItem(TOKEN_KEY);
  } catch {
    return null;
  }
}

export function getStoredUserId() {
  try {
    return localStorage.getItem(USER_ID_KEY);
  } catch {
    return null;
  }
}

export function persistAuthMeta(userId) {
  try {
    if (userId != null) localStorage.setItem(USER_ID_KEY, String(userId));
    localStorage.setItem(LAST_AUTH_AT_KEY, String(Date.now()));
  } catch {}
}

export function clearAuthToken() {
  try {
    localStorage.removeItem(TOKEN_KEY);
  } catch {}
}

export function clearAuthSession() {
  try {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_ID_KEY);
    localStorage.removeItem(LAST_AUTH_AT_KEY);
  } catch {}
}

export function notifyAuthChange(detail) {
  window.dispatchEvent(new CustomEvent(AUTH_EVENT, { detail }));
  try {
    const channel = new BroadcastChannel(CHANNEL_NAME);
    channel.postMessage(detail);
    channel.close();
  } catch {}
}

export function subscribeAuthChanges(onChange) {
  const onStorage = (event) => {
    if (event.key !== TOKEN_KEY) return;
    if (event.newValue) {
      onChange({ type: 'login', token: event.newValue });
    } else {
      onChange({ type: 'logout' });
    }
  };

  const onCustom = (event) => {
    onChange(event.detail);
  };

  let channel;
  try {
    channel = new BroadcastChannel(CHANNEL_NAME);
    channel.onmessage = (event) => onChange(event.data);
  } catch {}

  window.addEventListener('storage', onStorage);
  window.addEventListener(AUTH_EVENT, onCustom);

  return () => {
    window.removeEventListener('storage', onStorage);
    window.removeEventListener(AUTH_EVENT, onCustom);
    channel?.close();
  };
}
